import { atom } from "recoil";
const log =localStorage.getItem('login')
const loginState =atom({
    key: 'login',
    default: log
})

export default loginState